import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/index.scss';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { ru, en } from 'vuetify/locale';

const app = createApp(App);

const vuetify = createVuetify({
    components: {
        ...components,
    },
    directives,
    defaults: {
        VBtn: {
            color: 'secondary',
            size: 'large',
            rounded: 'lg',
            style: 'text-transform: none;',
        },
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#0eccaa',
                    secondary: '#4bace3',
                },
            },
        },
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
    locale: {
        locale: 'ru',
        fallback: 'en',
        messages: { ru, en },
    },
});

if (process.env.VUE_APP_IS_PROD == 0) {
    global.BACKEND_URL = 'http://localhost:8082'; //'http://medmob-cld-stage-web01:8080/backend_api/v1'
} else {
    global.BACKEND_URL = window.location.origin + '/backend_api/v1'; // :8082
}

app.use(router).use(vuetify);
if (navigator.userAgent.indexOf('Chrome/') > 0) {
    window.addEventListener('pageshow', () => {
        app.mount('#mapp');
    });
} else {
    app.mount('#mapp');
}
